// OTA PERMANENTLY DISABLED — user manually updates APK via Android Studio
// CapacitorUpdater causes reload loops on MIUI devices

export const checkForUpdates = async (): Promise<void> => {
  console.log('[OTA] Disabled — manual APK deployment only');
};
